import { render, staticRenderFns } from "./Mobiles.vue?vue&type=template&id=24668722&scoped=true&"
import script from "./Mobiles.vue?vue&type=script&lang=js&"
export * from "./Mobiles.vue?vue&type=script&lang=js&"
import style0 from "./Mobiles.vue?vue&type=style&index=0&id=24668722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24668722",
  null
  
)

export default component.exports